import { useViewer } from '@/stores/viewer';
import { ViewerV2 as Viewer3DV2 } from '@skand/viewer-component-v2';
import { Overlay } from './Overlay';

export const Viewer3D = () => {
  const viewer3DHandle = useViewer(state => state.viewer3DHandle);

  return (
    <div className="relative h-full">
      {viewer3DHandle && <Viewer3DV2 viewerHandle={viewer3DHandle} />}
      <Overlay />
    </div>
  );
};
